import { createStyles, Theme } from '@material-ui/core'
import {
  colorSectionHeadingOnLight,
  colorWhite,
  fullsizeAbsolute,
  shadowMainJoinHandsCard,
  shadowMainJoinHandsCardHover,
  transition,
} from '../../../../shared/style-settings'
import { makeStyles } from '@material-ui/core/styles'

export const useMainPageJoinHandsSectionStyles = makeStyles((theme: Theme) =>
  createStyles({
    joinHandsSection: {
      padding: 'calc(4vw + 30px) 20px',
      position: 'relative',
      textAlign: 'center',
    },
    sectionBgImage: {
      ...fullsizeAbsolute,
      zIndex: 0,
      backgroundSize: 'cover',
      backgroundPosition: '50% 50%',
      opacity: 0,
      transition: 'opacity 280ms ease-out',
      pointerEvents: 'none',
    },
    sectionBgImageVisible: {
      opacity: 1,
    },
    sectionBgLoader: {
      ...fullsizeAbsolute,
      zIndex: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colorWhite,
      opacity: 1,
      transition: 'opacity 240ms ease-out',
    },
    sectionBgLoaderHidden: {
      opacity: 0,
      pointerEvents: 'none',
    },
    joinHandsOverlay: {
      ...fullsizeAbsolute,
      zIndex: 1,
      background: theme.palette.primary.dark,
      opacity: 0.5,
    },
    joinHandsBlock: {
      background: colorWhite,
      maxWidth: 500,
      margin: '0 auto',
      zIndex: 3,
      position: 'relative',
      padding: theme.spacing(5, 6),
      borderRadius: theme.shape.borderRadius * 3,
      boxShadow: shadowMainJoinHandsCard,
      transition: transition,
      '&:hover': {
        boxShadow: shadowMainJoinHandsCardHover,
        transform: 'translateY(-8px) scale(1.02)',
      },
      [theme.breakpoints.down('md')]: {
        maxWidth: 450,
        padding: theme.spacing(4.5, 5),
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(4, 3),
        maxWidth: '90%',
      },
    },
    joinHandsText: {
      fontSize: 'clamp(24px, 3vw + 1vh, 44px)',
      fontWeight: 700,
      marginBottom: theme.spacing(4),
      color: colorSectionHeadingOnLight,
      lineHeight: 1.3,
      letterSpacing: '-0.02em',
      [theme.breakpoints.down('md')]: {
        fontSize: 'clamp(22px, 4vw, 36px)',
        marginBottom: theme.spacing(3.5),
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 'clamp(20px, 5vw, 32px)',
        marginBottom: theme.spacing(3),
      },
    },
    joinHandsBtnHolder: {
      '& .MuiButton-root': {
        borderRadius: theme.shape.borderRadius * 2,
        padding: theme.spacing(1.75, 5),
        fontWeight: 600,
        fontSize: 'clamp(14px, 1.2vw, 18px)',
        textTransform: 'initial',
        boxShadow: theme.shadows[4],
        transition: transition,
        width: '100%',
        '&:hover': {
          boxShadow: theme.shadows[8],
          transform: 'translateY(-3px)',
        },
        '&:disabled': {
          boxShadow: 'none',
        },
        [theme.breakpoints.down('md')]: {
          padding: theme.spacing(1.5, 4),
          fontSize: 'clamp(13px, 1.5vw, 17px)',
        },
        [theme.breakpoints.down('sm')]: {
          padding: theme.spacing(1.5, 3.5),
          fontSize: 'clamp(13px, 1.8vw, 16px)',
        },
      },
    },
  })
)
